import { FC } from 'react';

export const Crowdfunding: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"  fill="none">
    <circle cx="12" cy="5" r="3" stroke="currentColor" strokeWidth="2"></circle>
    <circle cx="12" cy="20" r="2" stroke="currentColor" strokeWidth="2"></circle>
    <circle cx="20" cy="20" r="2" stroke="currentColor" strokeWidth="2"></circle>
    <circle cx="4" cy="20" r="2" stroke="currentColor" strokeWidth="2"></circle>
    <path d="M20 15C20 13.8954 18.8807 13 17.5 13H6.5C5.11929 13 4 13.8954 4 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
    <path d="M12 11L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
</svg>
);

export default Crowdfunding;
